// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"001b6a2e","498":"ae7b3031","703":"45c43d05","787":"c922dae8"}[chunkId] + ".chunk.js";
};